// extracted by css-extract-rspack-plugin
export default {"TextPlaceholder":"assignees-renderer-module__TextPlaceholder___MS_5c4"};